import { NgModule } from '@angular/core';
import { PanelHeaderImageViewComponent } from './panel-header-image-view/panel-header-image-view.component';
import { AppContentPageWrapperComponent, DummyComponent } from './app-content-page-wrapper/app-content-page-wrapper.component';
import { RouterModule } from '@angular/router';
import { ThirdNavTabComponentComponent } from './third-nav-tab-component/third-nav-tab-component.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { LoadMoreButtonComponent } from './load-more-button/load-more-button.component';
import { HeadersComponentComponent } from './headers-component/headers-component.component';
import { WaTableComponent } from './wa-table/wa-table.component';
import { NgTemplateTableDirective, NgTemplateRowTableDirective, NgTemplateRowTableResponseDirective } from './ng-template-table.directive';
import { NumberBackgroundComponent } from './number-background/number-background.component';
import { NewsPanelComponent } from './news-panel/news-panel.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CommonTranslateModule } from './transloco-module/common-translate-module.module';
import { HoveredDirective } from "./hovered.directive";
import { WinLossEventComponent } from "./win-loss-event/win-loss-event.component";
import { NgTemplateRowGroupTableResponseDirective } from './ng-template-table.directive';
import { MatchHeightDirective } from './directives/match-height.directive';
import { CompetitionLinkDirective } from './directives/competition-link.directive';
import { PositionCompetitionRankPipe } from './pipes/position-competitition-rank.pipe';
import { PositionMedalsComponent } from './dummy-components/position-medals/position-medals.component';
import { RelatedAthletesPannelComponent } from './related-athletes-pannel/related-athletes-pannel.component';
import { ComponentsModule } from '../library/components/components/components.module';
import { ServicesModule } from '../library/components/components';
import { AthleteRecordsHistoryComponent } from '../athlete/athlete-records/components/athlete-records-history/athlete-records-history.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { LoadingContentComponent } from './loading-content/loading-content.component';
import { DateEventComponent } from './date-event/date-event.component';
import { CommonModule, DatePipe } from '@angular/common';
import { AdsenseModule } from 'ng2-adsense';
import { SearchBoxTableComponent } from './search-box-table/search-box-table.component';
import { NewsComponentComponent } from './news-component/news-component.component';
import { NewsSelectorFilterComponent } from './news-selector-filter/news-selector-filter.component';
import { AngularEmbedScript } from '../athlete/components/bootstrap-athlete/bootstrap-athlete.component';
import { GoogleAdsComponent } from './google-ads/google-ads.component';
import { LoadDrupalLangService } from './services/load-drupal-lang.service';
import { CustomLineChartComponent } from './custom-charts/custom-line-chart/custom-line-chart.component';
import { CustomTimelineChartComponent } from './custom-charts/custom-timeline-chart/custom-timeline-chart.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RouterHideDirective } from './utils/directives/router-hide.directive';
import { DateEventPipe } from './pipes/date-event.pipe';
import { TagsGenericComponent } from './tags-generic/tags-generic.component';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { AthleteInsightsComponent } from './athlete-insights/athlete-insights.component';
import { SeeMoreComponent } from './see-more/see-more.component';
import { WorldRankingDetailsComponent } from '../world-ranking-statistics/world-ranking/components/world-ranking-details/world-ranking-details.component';
import { TableMembersSearchItemComponent } from '../members/info-page/members-search/components/table-members-search-item/table-members-search-item.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { QuoteIndividualComponent } from './quote-individual/quote-individual.component';
import { OlympicInsightContainerComponent } from '../athlete/athlete-biography/components/olympic-insight-container/olympic-insight-container.component';

@NgModule({
  declarations: [
    PanelHeaderImageViewComponent,
    AppContentPageWrapperComponent,
    ThirdNavTabComponentComponent,
    LoadMoreButtonComponent,
    HeadersComponentComponent,
    WaTableComponent,
    NgTemplateTableDirective,
    TableMembersSearchItemComponent,
    NgTemplateRowTableDirective,
    NgTemplateRowTableResponseDirective,
    NgTemplateRowGroupTableResponseDirective,
    NumberBackgroundComponent,
    NewsPanelComponent,
    DummyComponent, // Component for testin
    HoveredDirective,
    WinLossEventComponent,
    MatchHeightDirective,
    CompetitionLinkDirective,
    PositionCompetitionRankPipe,
    PositionMedalsComponent,
    RelatedAthletesPannelComponent,
    AthleteRecordsHistoryComponent,
    LoadingContentComponent,
    DateEventComponent,
    SearchBoxTableComponent,
    NewsComponentComponent,
    NewsSelectorFilterComponent,
    AngularEmbedScript,
    GoogleAdsComponent,
    CustomLineChartComponent,
    CustomTimelineChartComponent,
    RouterHideDirective,
    DateEventPipe,
    TagsGenericComponent,
    CapitalizePipe,
    AthleteInsightsComponent,
    SeeMoreComponent,
    WorldRankingDetailsComponent,
    QuoteIndividualComponent,
    OlympicInsightContainerComponent
  ],
  imports: [
    LeafletModule.forRoot(),
    CommonModule,
    RouterModule,
    MatIconModule,

    MatMenuModule,
    SlickCarouselModule,
    CommonTranslateModule,
    LazyLoadImageModule,
    ComponentsModule,
    NgxChartsModule,
    AdsenseModule.forRoot()
  ],
  exports: [CommonTranslateModule,
    NewsPanelComponent,
    AdsenseModule,
    LoadMoreButtonComponent,
    NgTemplateRowTableResponseDirective,
    NgTemplateRowTableDirective,
    WaTableComponent,
    NgTemplateTableDirective,
    HeadersComponentComponent,
    PanelHeaderImageViewComponent,
    AppContentPageWrapperComponent,
    ThirdNavTabComponentComponent,
    NumberBackgroundComponent,
    ComponentsModule,
    LazyLoadImageModule,
    WinLossEventComponent,
    LoadingContentComponent,
    DateEventComponent,
    HoveredDirective,
    NewsPanelComponent,
    LoadMoreButtonComponent,
    NgTemplateRowTableResponseDirective,
    NgTemplateRowGroupTableResponseDirective,
    NgTemplateRowTableDirective,
    WaTableComponent,
    NgTemplateTableDirective,
    HeadersComponentComponent,
    PanelHeaderImageViewComponent,
    AppContentPageWrapperComponent,
    ThirdNavTabComponentComponent,
    NumberBackgroundComponent,
    MatchHeightDirective,
    CompetitionLinkDirective,
    PositionCompetitionRankPipe,
    PositionMedalsComponent,
    RelatedAthletesPannelComponent,
    ServicesModule,
    AthleteRecordsHistoryComponent,
    LazyLoadImageModule,
    ComponentsModule,
    SearchBoxTableComponent,
    TableMembersSearchItemComponent,
    NewsComponentComponent,
    NewsSelectorFilterComponent,
    AngularEmbedScript,
    GoogleAdsComponent,
    CustomLineChartComponent,
    RouterHideDirective,
    DateEventPipe,
    CapitalizePipe,
    TagsGenericComponent,
    AthleteInsightsComponent,
    SeeMoreComponent,
    WorldRankingDetailsComponent,
    LeafletModule,
    QuoteIndividualComponent,
    OlympicInsightContainerComponent
  ],
  providers:[
    LoadDrupalLangService,
    DatePipe
  ]

})
export class CommonPageComponentsModule { }
